import { AuthLevel } from '../enums/auth-level.enum';

export class AccessGroupUserAccess {
  public applicationId: string;
  public authLevel: AuthLevel;

  constructor(backEndAccessGroupUserAccess?: BackEndAccessGroupUserAccess) {
    if (backEndAccessGroupUserAccess) {
      this.applicationId = backEndAccessGroupUserAccess.application_id;
      this.authLevel = backEndAccessGroupUserAccess.auth_level;
    }
  }
}

export class AccessGroupUser {
  public email: string;
  public access: AccessGroupUserAccess[];

  constructor(backEndAccessGroupUser?: BackEndAccessGroupUser) {
    if (backEndAccessGroupUser) {
      this.email = backEndAccessGroupUser.email;
      this.access = backEndAccessGroupUser.access.map(a => new AccessGroupUserAccess(a));
    }
  }
}

//#region Backend
export interface BackEndAccessGroupUserList {
  group_id: string;
  users: BackEndAccessGroupUser[];
}

export interface BackEndAccessGroupUser {
  email: string;
  access: BackEndAccessGroupUserAccess[];
}

export interface BackEndAccessGroupUserAccess {
  application_id: string;
  auth_level: AuthLevel;
}
//#endregion Backend
